export default __webpack_public_path__ + "static/media/vizioecologo.56dc5337.png";